import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import BlogCard from "../BlogCard/BlogCard";
import "./BlogFilterSection.css";
import { insights as staticInsights } from "../../data.js";
import { useDispatch, useSelector } from "react-redux";
import { fetchInsights } from "../../features/insight/insightActions.js";

const BlogFilterSection = () => {
  const dispatch = useDispatch();
  const { insights: DynamicInsights, loading, error } = useSelector(state => state.insights);

  const [allInsights, setAllInsights] = useState([])
  const [filteredInsights, setFilteredInsights] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const insightsPerPage = 6;
  useEffect(() => {
    dispatch(fetchInsights());
  }, [dispatch]);
  useEffect(() => {
    const mergedInsights = [...staticInsights, ...DynamicInsights];
    setAllInsights(mergedInsights);
  }, [DynamicInsights]);

  useEffect(() => {
    if (selectedCategory === "All") {
      setFilteredInsights(allInsights);
    } else {
      const filtered = allInsights.filter((insight) =>
        insight.category?.includes(selectedCategory)
      );
      setFilteredInsights(filtered);
    }
    setCurrentPage(1); // reset pagination on category change
  }, [selectedCategory, allInsights]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "4rem 0", color: "#999" }}>
        <h3>Loading blogs...</h3>
      </div>
    );
  }
  if (error) {
    console.error("Error fetching blogs:", error);
  }

  // pagination
  const indexOfLastInsight = currentPage * insightsPerPage;
  const indexOfFirstInsight = indexOfLastInsight - insightsPerPage;
  const currentInsights = filteredInsights.slice(indexOfFirstInsight, indexOfLastInsight);

  const handleNext = () => {
    if (indexOfLastInsight < filteredInsights.length) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const categories = [
    "All",
    "Eye Health",
    "Vision Technology",
    "Lens Care",
    "Eyewear Trends",
    "News & Events",
  ];
  const filteredPosts =
    selectedCategory === "All"
      ? currentInsights
      : currentInsights.filter((post) => post.category === selectedCategory);
  return (
    <section className="blog-filter-section align-items-center">
      <Container>
        <div className="d-flex justify-content-between align-items-center mb-5 flex-wrap">

          <div className="filter-buttons">
            {categories.map((cat) => (
              <button
                key={cat}
                className={`filter-btn ${selectedCategory === cat ? "active" : ""
                  }`}
                onClick={() => setSelectedCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
          <div style={{ display: "flex", justifyContent: "end", gap: "1rem", alignItems: "center" }}  >
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1}
              style={{
                padding: "",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
              className="hero-btn-primary hover-noeffect"
            >
              Previous
            </button>
            <button
              className="hero-btn-primary hover-noeffect"
              onClick={handleNext}
              disabled={indexOfLastInsight >= filteredInsights.length}
              style={{
                padding: "",
                cursor: indexOfLastInsight >= filteredInsights.length ? "not-allowed" : "pointer",
              }}
            >
              Next
            </button>
          </div>
        </div>

        <Row className="g-4">
          {filteredPosts.map((post, index) => (
            <Col md={4} sm={6} xs={12} key={index}>
              <BlogCard {...post} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default BlogFilterSection;
